export default __webpack_public_path__ + "static/11-3124400d225dd2688dd1820f156936d9.jpg";